import { useMutation } from '@tanstack/react-query'

import { postCancelRequestForEvidenceRequest } from '@src/api'
import { DefaultApiPostCancelRequestForEvidenceRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostCancelRequestForEvidenceRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiPostCancelRequestForEvidenceRequestRequest
    ) => postCancelRequestForEvidenceRequest(axiosInstance, params),
  })
}
